import React from "react";
import {Navbar} from "@/components/layouts/navbar";
import {useAuth} from "@/context/AuthContext";

export function Header({ className, ...props }) {

    const {auth} = useAuth();

    return (
        <header className="supports-backdrop-blur:bg-background/60 sticky top-0 z-50 w-full border-b border-slate-200/70 bg-background/95 backdrop-blur h-[40px] gradient-background" style={{
            background: `linear-gradient(90deg, white 0%, ${auth?.user?.instcolor ?? '#FFF'} 30%, ${auth?.user?.instcolor ?? '#FFF'} 70%, white 100%)`
        }}>
            <div className="flex items-center px-8 h-full">
                <Navbar />
            </div>
        </header>
    );
}